const zinkhin = {
    title: "Hardware Modelling Intern",
    company: "Zinkhin",
  };
  
  export default zinkhin;